Controller.$inject = ['$filter', '$timeout', '$element'];

function Controller($filter, $timeout, $element) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;
    self.isDateRangeShown = false;

    self.handleFocus = () => {
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
        self.toggleDateRangePicker();
    };

    self.handleBlur = () => {
        if (!self.rangeFrom && !self.rangeTo) {
            self.showLegend = false;
        }
        self.inputFocused = false;
    };

    self.toggleDateRangePicker = () => {
        self.isDateRangeShown = !self.isDateRangeShown;
    };

    self.handleRangeApplied = (event) => {
        self.onRangeApplied({range: event.range, from: event.from, to: event.to});
        self.isDateRangeShown = false;
    };

    self.getSelectedRange = ()=> {
        const inputElement = $element[0].querySelector('input[type="text"]');
        if (self.rangeFrom && self.rangeTo) {
            inputElement.classList.remove('placeholder');
            return self.rangeFrom.format('MMM DD, YYYY') + ' - ' +
                self.rangeTo.format('MMM DD, YYYY');
        } else {
            inputElement.classList.add('placeholder');
        }
        return self.placeholder || $filter('translate')('Select Range');
    };

    self.$postLink = () => {
        $timeout(() => {
            if (self.labelVariant === 'outlined') {
                self.showLegend = true;
            }
        });
    };
}

export function HuiInputDateRange() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            disablePeriods: '<',
            rangeFrom:'<',
            rangeTo:'<',
            minDate: '<',
            maxDate: '<',
            period:'<',
            isClearEnabled: '<',
            ngDisabled: '<',
            onRangeApplied: '&',
            startDayOfWeek: '<',
            buttonText: '<',
            dateRangeAlignment: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon'
        },
        template: ($element, $attrs) => {
            return `
              <div class="date-range-shade"
                   ng-hide="!$huiCtrl.isDateRangeShown"
                   ng-click="$huiCtrl.isDateRangeShown = false;"></div>
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                icon-position="end"
                has-error="$huiCtrl.hasError"
                show-legend="$huiCtrl.showLegend"
                input-focused="$huiCtrl.inputFocused"
                disabled="$huiCtrl.disabled">
                 <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                 <hui-input-base-icon><i class="fa fa-calendar"></i></hui-input-base-icon>
               
                 <input type="text"
                        readonly
                        ng-value="$huiCtrl.getSelectedRange()"
                        ng-disabled="$huiCtrl.disabled"
                        name="{{$huiCtrl.hName}}"
                        placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder  : ''}}"
                        ng-focus="$huiCtrl.handleFocus()"
                        ng-blur="$huiCtrl.handleBlur()"
                        class="hui-base-input hui-input-select hui-input-date-range"
                 />
                         
                <h-date-range-picker
                    ng-class="{
                        'expanded': $huiCtrl.isDateRangeShown,
                        'date-range-left': $huiCtrl.dateRangeAlignment === 'left'}"
                    range-from="$huiCtrl.rangeFrom"
                    range-to="$huiCtrl.rangeTo"
                    min-date="$huiCtrl.minDate"
                    max-date="$huiCtrl.maxDate"
                    period="$huiCtrl.period"
                    disable-periods="$huiCtrl.disablePeriods"
                    button-text="$huiCtrl.buttonText"
                    is-clear-enabled="$huiCtrl.isClearEnabled"
                    start-day-of-week="$huiCtrl.startDayOfWeek"
                    on-range-applied="$huiCtrl.handleRangeApplied({range: range, from: from, to: to})">
                </h-date-range-picker>
            
              </hui-input-base>
             `;
        }
    };
}


